import { GenericMoleculeOverviewRowPanelDashboardComponent } from '../abstract';

// tslint:disable-next-line:max-line-length
export class MoleculeOverviewRowPanelDashboardDnsZonesComponent extends GenericMoleculeOverviewRowPanelDashboardComponent {
    public template = require('./dashboard-dns-zones.html');
    protected type = 'dns-zones';
}
